import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  CreateOrderResponse,
  DownloadPayLoad,
  DownloadStatusPayLoad,
  LockerAvailabilityPayLoad,
  LockerRoutePayLoad,
  OrderPayload,
} from "type/shipNow";

export const shipNow = createApi({
  reducerPath: "shipNow",
  baseQuery: customBaseQuery,
  tagTypes: ["Order"],
  endpoints: (builder) => ({
    extractOrder: builder.mutation<any, any>({
      query: (body) => ({
        url: `orders/extract`,
        method: "POST",
        body,
      }),
    }),
    updateReferral: builder.mutation<any, any>({
      query: (body) => ({
        url: `orders/referrals-update`,
        method: "POST",
        body,
      }),
    }),
    getAllOrders: builder.mutation<any, OrderPayload>({
      query: (body) => ({
        url: `/orders/clusterSearch`,
        method: "POST",
        body,
      }),
    }),
    getAllOrderStats: builder.mutation<any, OrderPayload>({
      query: (body) => ({
        url: `/orders/clusterSearch`,
        method: "POST",
        body,
      }),
    }),
    getAllLocalStats: builder.mutation<any, OrderPayload>({
      query: (body) => ({
        url: `/orders/clusterSearch`,
        method: "POST",
        body,
      }),
    }),
    getAllImportStats: builder.mutation<any, OrderPayload>({
      query: (body) => ({
        url: `/orders/clusterSearch`,
        method: "POST",
        body,
      }),
    }),
    getAllExportStats: builder.mutation<any, OrderPayload>({
      query: (body) => ({
        url: `/orders/clusterSearch`,
        method: "POST",
        body,
      }),
    }),
    getAllSafeLockerStats: builder.mutation<any, OrderPayload>({
      query: (body) => ({
        url: `/orders/clusterSearch`,
        method: "POST",
        body,
      }),
    }),
    editShipment: builder.mutation<any, any>({
      query: (body) => ({
        url: `order/multiple`,
        method: "PUT",
        body,
      }),
    }),
    getSingleOrder: builder.query<any, string>({
      query: (id) => ({
        url: `orders/${id}`,
        method: "GET",
      }),
    }),
    getCountry: builder.query<any, void>({
      query: () => ({
        url: `orders/all-import-locations`,
        method: "GET",
      }),
    }),

    getExportCountry: builder.query<any, void>({
      query: () => ({
        url: `orders/export-locations`,
        method: "GET",
      }),
    }),
    getItemCategory: builder.query<any, void>({
      query: () => ({
        url: `orders/item-categories`,
        method: "GET",
      }),
    }),
    getOrderWeight: builder.query<any, any>({
      query: ({ id }) => ({
        url: `orders/int/weights?intLocation=${id}`,
        method: "GET",
      }),
    }),
    getSafeLockers: builder.query<any, string>({
      query: (state) => ({
        url: `Lockers/${state}`,
        method: "GET",
      }),
    }),
    order: builder.mutation<CreateOrderResponse, any>({
      query: ({ body, requestType }) => ({
        url: `order${requestType ? `?requestType=${requestType}` : ""}`,
        method: "POST",
        body,
      }),
    }),
    removePendingOrder: builder.mutation<any, any>({
      query: (body) => ({
        url: `orders/removePendingPayment`,
        method: "POST",
        body,
      }),
    }),
    checkLockerRoute: builder.mutation<any, LockerRoutePayLoad>({
      query: (body) => ({
        url: `lockers/check-route-support`,
        method: "POST",
        body,
      }),
    }),
    getLockerAvailability: builder.query<any, LockerAvailabilityPayLoad>({
      query: ({ lockerID }) => ({
        url: `LockerAvailability/${lockerID}`,
        method: "GET",
      }),
    }),
    downloadCreate: builder.mutation<any, DownloadPayLoad>({
      query: (body) => ({
        url: `orders/download/create`,
        method: "POST",
        body,
      }),
    }),
    downloadStatus: builder.mutation<any, DownloadStatusPayLoad>({
      query: (body) => ({
        url: `orders/download/status`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useExtractOrderMutation,
  useOrderMutation,
  useRemovePendingOrderMutation,
  useUpdateReferralMutation,
  useGetAllOrdersMutation,
  useGetSingleOrderQuery,
  useEditShipmentMutation,
  useGetAllOrderStatsMutation,
  useGetAllExportStatsMutation,
  useGetAllImportStatsMutation,
  useGetAllLocalStatsMutation,
  useGetAllSafeLockerStatsMutation,
  useGetCountryQuery,
  useGetExportCountryQuery,
  useGetItemCategoryQuery,
  useGetOrderWeightQuery,
  useGetSafeLockersQuery,
  useGetLockerAvailabilityQuery,
  useDownloadCreateMutation,
  useDownloadStatusMutation,
  useCheckLockerRouteMutation,
} = shipNow;
